export const scrollTop = () => window.scroll({left: 0, top: 0})
export const customReplaceAll = (text, simbol1, simbol2) =>{  
   text?.replaceAll(simbol1, simbol2)
  }

export const splitGivenDescription = (text) => {
  if (!text || typeof text !== "string")
    return {
      text1: "",
      text2: "",
    };
  let text1 = "",
    text2 = "";
  text?.split(".").forEach((piece, index) => {
    if (index === 0) {
      text1 = piece + ".";
    } else {
      text2 += piece + ".";
    }
  });
  return { text1, text2: text2.slice(0, -1) };
};

export const formatTextForCard = (tag = 'title', text, shouldTrim = true) => {
  if(!text){ 
    return ''
  }
  const longToCut = !shouldTrim? text.length : tag === 'title'? 70 : 150; 
  const customText = JSON.stringify(text).replaceAll('\\','').replaceAll('"','').replaceAll('.rn','');
  return customText.length <= longToCut ? customText : customText.slice(0, longToCut) + '...';
}

export function redireccionarWhatsApp() {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const numeroTelefono = "+5491162676211";
  const mensaje = encodeURIComponent("Hola! Te contacto desde la web.");

  let urlWhatsApp;

  if (isMobile) {
    // Redirección a la aplicación móvil
    urlWhatsApp = `https://wa.me/${numeroTelefono}?text=${mensaje}`;
  } else {
    // Redirección a WhatsApp Web
    urlWhatsApp = `https://web.whatsapp.com/send?phone=${numeroTelefono}&text=${mensaje}`;
  }

  window.location.href = urlWhatsApp;
}